import React from "react";

const Report = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="m24.543 2 7.901 8v22.413c0 .42-.166.825-.46 1.122a1.56 1.56 0 0 1-1.109.465H5.57a1.57 1.57 0 0 1-1.106-.468A1.61 1.61 0 0 1 4 32.412V3.588C4 2.71 4.703 2 5.57 2h18.973Zm-7.901 8v16h3.16V10h-3.16Zm6.321 6.4V26h3.16v-9.6h-3.16Zm-12.642 3.2V26h3.16v-6.4h-3.16Z"
              fill={fill}/>
    </svg>
);

export default Report;